/**
 * Determines the lender based on the provided custom rate or payment service lender.
 *
 * @param {number|null} customRate - The custom rate provided by the user. If it's a number, the lender is set to 'Custom Rate'.
 * @param {string} [paymentServiceLender] - The name of the payment service lender. Defaults to 'National Average Rate' if not provided.
 *
 * @returns {string} The determined lender, which can be 'Custom Rate', the provided payment service lender, or 'National Average Rate'.
 */
const determineLender = (customRate, paymentServiceLender) => {
  const lender = typeof customRate === 'number' ? 'Custom Rate' : paymentServiceLender || 'National Average Rate';
  return lender;
};
export { determineLender as default };
